import {createSelector} from 'reselect'
import {selectTaskManagement} from '../selectors'
import {getViewMode} from "../common/selectors"
import {TaskManagementViewMode, TaskSortBy} from "../constants"
import {Feature, isEnabled} from "../../features/index"
import {getCustomers, getProjects} from "../../entities/selectors"
import {arrayToSet} from "../../atUtils"
import TaskManagementStore from '../TaskManagementStore'
import {isBTYEnabled, isESTEnabled} from '../../features/selectors'

const getTaskTableState = (state) => selectTaskManagement(state).taskTable

export const getColumnsOrder = (state) => getTaskTableState(state).columnsOrder

export const getShownColumns = (state) => getTaskTableState(state).columnsShown

export const getFilteredColumnsOrder = createSelector(
    getColumnsOrder,
    isESTEnabled,
    isBTYEnabled,
    (order, isESTEnabled, isBTYEnabled) => {
        return order.filter((column) => !((column === TaskSortBy.ESTIMATE && !isESTEnabled) || (column === TaskSortBy.TYPE_OF_WORK && !isBTYEnabled)))
    }
)

export const getShownColumnsWithOrder = createSelector(
    getFilteredColumnsOrder,
    getShownColumns,
    (order, shown) => {
        const shownSet = arrayToSet(shown)
        return order.filter((column) => !!shownSet[column])
    }
)

export const getTasksSorting = createSelector(
    getTaskTableState,
    (taskTable) => {
        const sorting = taskTable.sorting
        if (isEnabled(Feature.TWS) && sorting.by === TaskSortBy.STATUS) {
            return {
                ...sorting,
                by: TaskSortBy.WORKFLOW_STATUS
            }
        }

        if (!isEnabled(Feature.TWS) && sorting.by === TaskSortBy.WORKFLOW_STATUS) {
            return {
                ...sorting,
                by: TaskSortBy.STATUS
            }
        }

        return sorting
    }
)

export const isLoaded = state => getTaskTableState(state).isLoaded

export const isNeedToReloadTasks = createSelector(
    getViewMode,
    isLoaded,
    (viewMode, isLoaded) => viewMode === TaskManagementViewMode.TABLE && isLoaded === false
)

export const getArchivedProjectIds = createSelector(
    getProjects,
    (projects) => arrayToSet(Object.values(projects).filter(p => p.archived).map(p => p.id))
)

export const getArchivedCustomerIds = createSelector(
    getCustomers,
    (customers) => arrayToSet(Object.values(customers).filter(c => c.archived).map(c => c.id))
)

/**
 * @Deprecated but used in many places
 */
export const getVisibleTableTaskIds = () => TaskManagementStore.getTaskIds()

/**
 * Like `getVisibleTableTaskIds` but used only for SelectionController
 */
export const getLoadedTaskIds = createSelector(
    getTaskTableState,
    (taskTableState) => taskTableState.loadedTaskIds
)

export const thereAreTableTasks = createSelector(
    getLoadedTaskIds,
    (taskIds) => taskIds.length !== 0
)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/selectors.js